import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IEffectName } from 'app/shared/model/effect-name.model';
import { EffectCategory } from 'app/shared/model/enumerations/effect-category.model';
import { getEntity, updateEntity, createEntity, reset } from './effect-name.reducer';

export const EffectNameUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const effectNameEntity = useAppSelector(state => state.effectName.entity);
  const loading = useAppSelector(state => state.effectName.loading);
  const updating = useAppSelector(state => state.effectName.updating);
  const updateSuccess = useAppSelector(state => state.effectName.updateSuccess);
  const effectCategoryValues = Object.keys(EffectCategory);

  const handleClose = () => {
    navigate('/effect-name');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  // eslint-disable-next-line complexity
  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.displayOrder !== undefined && typeof values.displayOrder !== 'number') {
      values.displayOrder = Number(values.displayOrder);
    }

    const entity = {
      ...effectNameEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          category: 'INFLAMMATION',
          ...effectNameEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="coconApp.effectName.home.createOrEditLabel" data-cy="EffectNameCreateUpdateHeading">
            <Translate contentKey="coconApp.effectName.home.createOrEditLabel">Create or edit a EffectName</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="effect-name-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('coconApp.effectName.name')}
                id="effect-name-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('coconApp.effectName.category')}
                id="effect-name-category"
                name="category"
                data-cy="category"
                type="select"
              >
                {effectCategoryValues.map(effectCategory => (
                  <option value={effectCategory} key={effectCategory}>
                    {translate('coconApp.EffectCategory.' + effectCategory)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('coconApp.effectName.displayOrder')}
                id="effect-name-displayOrder"
                name="displayOrder"
                data-cy="displayOrder"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/effect-name" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EffectNameUpdate;
